import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['styles.css'
  ]
})
export class UsersComponent implements OnInit {

  public users;
  public inactives = false;
  public evaluated = false;
  public tests = [];
  public inTrash = false;
  public selectedUser;
  public selectedName;
  public firstBuy = false;
  public filter = '';

  constructor( private userService: UserService, private router: Router, private testService:TestService ) {

    this.userService.getUsersWithPayments().subscribe(
      resp=>{
        this.users = resp
        this.users.sort((a,b)=>{
          let dateA = new Date(a.registerDate);
          let dateB = new Date(b.registerDate);
          return dateB.getTime() - dateA.getTime();
        })
      },
      err=>console.log(err)
    )
  }

  handleEdit(email){
    this.userService.getUserByEmail(email).subscribe(
      resp=>{
        this.userService.selectedUser = resp;
        this.router.navigateByUrl('/dashboard/editUser');
      },
      err=>console.log(err)
    );
  }

  ngOnInit(): void {
  }

  changeState(user){
    this.userService.updateUser({email:user.email, active:!user.active}).subscribe(
      resp=>{
        window.location.reload();
      },
      err=>console.log(err)
    )
  }

  viewEvaluations(user){
    this.tests = [];
    this.selectedUser = user.email;
    this.selectedName = `${user.name} ${user.surname}`;
    this.testService.getClientTests(user.email).subscribe(
      resp=>{
        resp.map(
          x=>{
            if (!x.trash){
              this.tests.push(x);
            }
          }
        )

      },
      err=>console.log(err)
    )
  }

  reloadTest(test){

    Swal.fire({
      text:"¿Reiniciar test para este usuario?",
      showCancelButton:true
    }).then(result=>{

      if(result.isConfirmed){
        var testData = test;
        testData.isStarted = false;
        this.testService.updateTest(testData).subscribe(
          resp=>{
            window.location.reload();
          },
          err=>console.log(err)
        )

      }

    })
  }

  trash(test){
    var text;
    if(test.trash) text = "¿Restaurar?";
    else text = "¿Enviar a la papelera?";  
    Swal.fire({
      text:text,
      showCancelButton:true
    }).then(result=>{

      if(result.isConfirmed){
        var testData = test;
        testData.trash = !testData.trash;
        this.testService.updateTest(testData).subscribe(
          resp=>{
            window.location.reload();
          },
          err=>console.log(err)
        )

      }

    })
  }

  showTrash(){
    this.inTrash = true;
    this.tests = [];

        
    this.testService.getClientTests(this.selectedUser).subscribe(
      resp=>{
        resp.map(
          x=>{
            if (x.trash){
              this.tests.push(x);
            }
          }
        )
        
      },
      err=>console.log(err)
    )


  }


  back(){
    this.inTrash = !this.inTrash;
    this.tests = [];
    this.testService.getClientTests(this.selectedUser).subscribe(
      resp=>{
        resp.map(
          x=>{
            if (!x.trash){
              this.tests.push(x);
            }
          }
        )

      },
      err=>console.log(err)
    )
  }

  toggleNotClients(e){
    
    let value = e.target.checked
  }

  setYearDate(dateString: string): Date {
    let date = new Date(dateString);
    date.setFullYear(date.getFullYear() + 1);
    return date;
  }

}
